
$(document).ready(function () {

    function checkIfSame() {
        if (JSON.stringify(window.before_changes) !== JSON.stringify(window.after_changes)) {
            return false;
        } else {
            return true;
        }
    }

    function addFields(obj) {
        jQuery('input, textarea, select').each(function () {
            var identifier = jQuery(this).attr('name');
            var value = jQuery(this).val();
            if (jQuery(this).attr('type') === "checkbox") {
                if (jQuery(this).prop("checked") == true) {
                    obj[identifier] = "checked";
                } else {
                    obj[identifier] = "unchecked";
                }
            } else {
                obj[identifier] = value;
            }
        });
        return obj;
    }

    function doTheButtons() {
        window.after_changes = addFields({});
        if (!checkIfSame()) {
            jQuery('form').find('button[type="submit"]').removeAttr('disabled');
        } else {
            jQuery('form').find('button[type="submit"]').attr('disabled', true);
        }
        doTitle();
    }

    function doTitle() {
        if (!checkIfSame()) {
            console.log("not same");
            if (jQuery('body').find('.save-changes-message').length < 1) {
                jQuery('h5.navbar-title').append("<span class='save-changes-message'>( <i class='fas fa-exclamation-triangle text-warning'></i>" + __('Changes made, Please save the changes') + ".)</span>");
            }
        } else {
            console.log("same");
            if (jQuery('body').find('.save-changes-message').length > 0) {
                jQuery('body').find('.save-changes-message').remove();
            }
        }
    }

    if (jQuery('body').find('.admin_button_logic').length > 0) {
        jQuery('body').find('button[type="submit"]').attr('disabled', true);
        window.before_changes = addFields({});
        window.after_changes = addFields({});

        jQuery('body').on('keyup', 'input, textarea', function () {
            doTheButtons();
        });

        jQuery('body').on('change', 'input, form, file', function () {
            doTheButtons();
        });

        jQuery('body').on('click, mouseenter, mouseleave', 'select', function () {
            doTheButtons();
        });

        jQuery('body').on('mouseenter, mouseleave, mouseover', 'button[type="submit"]', function () {
            doTheButtons();
        });
    }



    if (jQuery('.admin-simple').length > 0) {

        var val = jQuery('.select-company').val();
        if (val) {
            jQuery.ajax("/business/" + val + "/distributors/ajax").then(
                (success) => {
                    var html = "";
                    if (success.length > 0) {
                        jQuery('.distributors-box').parent().removeClass('hidden');
                        for (i = 0; i < success.length; i++) {
                            var row = `
                            <div class="col-sm-12 distributor-row pt-1 pb-1">
                                <div class="row align-items-center d-flex admin-simple-company-details">
                                    <div class="container-fluid w-100 admin-simple-select-company d-flex">
                                        <div>
                                            ${success[i].name}
                                        </div>
                                        <div>
                                            ${success[i].phone}
                                        </div>
                                        <div>
                                            ${success[i].email}
                                        </div>
                                    </div>
                                    <div class="container-fluid w-100 mt-2">
                                        <a href="/business/${val}/distributors/${success[i].user_id}/remove/ajax" data-id="${success[i].user_id}" class="btn btn-outline-primary remove-access"><i class="fas fa-times-circle mr-1"></i>Remove Access</a>
                                    </div>
                                </div>
                            </div>
                        `;
                            html += row;
                        }
                        // console.log(html);
                        jQuery('.distributors-box').html(html);
                        jQuery('.business-name').text(jQuery('.select2-selection').first().text());
                    } else {
                        jQuery('.distributors-box').parent().addClass('hidden');
                    }
                },
                (error) => console.log(error),
            );
        }


        // RTF-3975 - prevent dropdown before select2 is initialized
        function isSelect2Initialized($el) {
            return $el.hasClass('select2-hidden-accessible') && $el.next('.select2').length > 0;
        }

        const $select = $('.select-company');

        if (!isSelect2Initialized($select)) {
            $select.prop('disabled', false);
            $select.select2({
                width: "calc(100% - 50px)"
            });
        }

        $('#includeCanceledToggle').on('change', function() {
            const includeCanceled = $(this).is(':checked');

            $.ajax({
                url: '/businesses/get-list-ajax',
                type: 'GET',
                data: { includeCanceled: includeCanceled },
                success: function(data) {
                    const $select = $('.select-company');
                    $select.empty();

                    $select.append('<option></option>');

                    data.forEach(function(business) {
                        $select.append(new Option(business.name, business.business_id));
                    });

                    $select.select2({
                        placeholder: __("Select a Company"),
                        width: "calc(100% - 50px)",
                    });
                },
                error: function() {
                    alert(__('Failed to retrieve company list. Please try again.'));
                }
            });
        });


        $('.select-user').select2({
            placeholder: __("Select a Distributor"),
            width: "calc(100% - 50px)",
        });
        $('.search-users').select2({
            placeholder: __("Search a User"),
            width: "calc(100% - 50px)",
        });
        $('.select-msa').select2({
            placeholder: __("Select Business Group"),
            width: "calc(100% - 50px)",
        });

        jQuery('body').on('click', '.select-business-button', function (e) {
            e.preventDefault();
            var val = jQuery('.select-company').val();
            if (val) {
                window.location = "/view-as-business/login/" + val;
            }
        });

        jQuery('body').on('click', '.login-this-user-button', function (e) {
            e.preventDefault();
            var val = jQuery('.search-users').val();
            if (val) {
                window.location = `/view-as-user/login/${val}`;
            }
        });

        jQuery('body').on('change', '.select-company', function () {
            var val = jQuery('.select-company').val();
            jQuery.ajax("/business/" + val + "/distributors/ajax").then(
                (success) => {
                    console.log(success.length);
                    var html = "";
                    if (success.length > 0) {
                        jQuery('.distributors-box').parent().removeClass('hidden');
                        for (i = 0; i < success.length; i++) {
                            var row = `
                        <div class="col-sm-12 distributor-row pt-1 pb-1">
                            <div class="row align-items-center d-flex admin-simple-company-details">
                                <div class="container-fluid w-100 admin-simple-select-company d-flex">
                                        <div>
                                            ${success[i].name}
                                        </div>
                                        <div>
                                            ${success[i].phone}
                                        </div>
                                        <div>
                                            ${success[i].email}
                                        </div>
                                    </div>
                                <div class="container-fluid w-100 mt-2">
                                    <a href="/business/${val}/distributors/${success[i].user_id}/remove/ajax" data-id="${success[i].user_id}" class="btn btn-outline-primary remove-access w-100"><i class="fas fa-times-circle mr-1"></i> Remove Access</a>
                                </div>
                            </div>
                        </div>
                    `;
                            html += row;
                        }
                        console.log(html);
                        jQuery('.distributors-box').html(html);
                        jQuery('.business-name').text(jQuery('.select2-selection').first().text());
                    } else {
                        jQuery('.distributors-box').parent().addClass('hidden');
                    }
                },
                (error) => console.log(error),
            );

        });

        jQuery('body').on('click', '.assign-button', function (e) {
            e.preventDefault();
            if (jQuery('.select-company').val() && jQuery('.select-company').val() != "" && jQuery('.select-user').val() && jQuery('.select-company').val() != "") {
                var business = jQuery('.select-company').val();
                var user = jQuery('.select-user').val();
                var csrf = jQuery("[name=csrf-token]").attr('content');
                var data = { 'business_id': business, 'user_id': user, '_token': csrf };
                jQuery.post("/business/" + business + "/distributors/ajax/post", { data: data }).then(
                    (success) => {
                        console.log(success.length);
                        var html = "";
                        if (success.length > 0) {
                            jQuery('.distributors-box').parent().removeClass('hidden');
                            for (i = 0; i < success.length; i++) {
                                var row = `
                            <div class="col-sm-12 distributor-row pt-1 pb-1">
                                <div class="row align-items-center">
                                    <div class="col-4">
                                        ${success[i].name}
                                   </div>
                                   <div class="col-3">
                                       ${success[i].phone}
                                   </div>
                                   <div class="col-3">
                                      ${success[i].email}
                                   </div>
                                   <div class="col-2">
                                       <a href="/business/${business}/distributors/${success[i].user_id}/remove/ajax" data-id="${success[i].user_id}" class="btn btn-outline-primary remove-access"><i class="fas fa-times-circle mr-1"></i> Remove Access</a>
                                   </div>
                                </div>
                            </div>
                         `;
                                html += row;
                            }
                            console.log(html);
                            jQuery('.distributors-box').html(html);
                            jQuery('.business-name').text(jQuery('.select2-selection').first().text());
                        } else {
                            jQuery('.distributors-box').parent().addClass('hidden');
                        }
                    },
                    (error) => console.log(error),
                );

            }
        });

        jQuery('body').on('click', '.remove-access', function (e) {
            e.preventDefault();
            if (jQuery('.select-company').val() && jQuery('.select-company').val() != "") {
                var business = jQuery('.select-company').val();
                var user = jQuery(this).attr('data-id');
                var csrf = jQuery("[name=csrf-token]").attr('content');
                var data = { 'business_id': business, 'user_id': user, '_token': csrf };
                jQuery.post("/business/" + business + "/distributors/ajax/post/remove", { data: data }).then(
                    (success) => {
                        console.log(success.length);
                        var html = "";
                        if (success.length > 0) {
                            jQuery('.distributors-box').parent().removeClass('hidden');
                            for (i = 0; i < success.length; i++) {
                                var row = `
                            <div class="col-sm-12 distributor-row pt-1 pb-1">
                                <div class="row align-items-center">
                                    <div class="col-4">
                                        ${success[i].name}
                                   </div>
                                   <div class="col-3">
                                       ${success[i].phone}
                                   </div>
                                   <div class="col-3">
                                      ${success[i].email}
                                   </div>
                                   <div class="col-2">
                                       <a href="/business/${business}/distributors/${success[i].user_id}/remove/ajax" data-id="${success[i].user_id}" class="btn btn-outline-primary remove-access"><i class="fas fa-times-circle mr-1"></i> Remove Access</a>
                                   </div>
                                </div>
                            </div>
                         `;
                                html += row;
                            }
                            console.log(html);
                            jQuery('.distributors-box').html(html);
                            jQuery('.business-name').text(jQuery('.select2-selection').first().text());
                        } else {
                            jQuery('.distributors-box').parent().addClass('hidden');
                        }
                    },
                    (error) => console.log(error),
                );

            }
        });

        // NEW: Select MSA
        // 1. Log In to Business Group as MSA (first user)
        // 2. Add Edit URL on button
        jQuery('body').on('change', '.select-msa', function () {
            const $msaSelect = jQuery('.select-msa');
            const firstUserUrl = $msaSelect.find(':selected').data('user');
            const $loginButton = $('.select-msa-button');
            const businessGroupIdUrl =  $msaSelect.find(':selected').data('url');
            const $viewBusinessGroupBtn = $('.edit-msa-button');

            // if Business Group has MSA, add to button
            if (firstUserUrl) {
                $loginButton.attr("disabled", false);
                $loginButton.attr("href", firstUserUrl)
            } else {
                $loginButton.attr("disabled", true);
                $loginButton.attr("href", "#");
            }

            // add Business Group link to button
            $viewBusinessGroupBtn.attr("href", businessGroupIdUrl);
        })
    }

});
